import React from "react";
import { withRouter } from "react-router";
import styled from "styled-components";

import Feedback from "./feedbackResponse";
import Auth from "routes/Auth";
import Teams from "api/Teams";
import { getRequest, postRequest, putRequest } from "api/ApiService";

import _ from "lodash";

import moment from "moment";
import PeerEvaluationCard from "../peer-evaluation/peer-evaluation-card";
import PeerEvaluationModal from "../peer-evaluation/peer-evaluation-modal";

const FinalMessage = styled.div`
  font-family: Lato;
  font-size: 24px;
  text-align: center;
  padding-top: 50px;
`;

class Quiz extends React.Component {
  constructor(props) {
    super(props);

    const userId = parseInt(Auth.getUserId(), 10);

    let hasSelfAssessmentQuestions = false;
    if (
      props.survey &&
      props.survey.questions &&
      props.survey.questions.length > 0
    ) {
      const self_assessment_question = props.survey.questions.find(
        i => i.category === "self_assessment"
      );
      if (self_assessment_question) {
        hasSelfAssessmentQuestions = true;
      }
    }

    let nonCurrentUserId = 0;
    const team = Teams.currentTeam();
    const players = Teams.players();

    if (team && players && players.length > 0) {
      const teammates = players.filter(player => {
        return player.user
          ? player.team === team.id && player.user.id !== userId
          : false;
      });

      if (teammates && teammates.length > 0) {
        const teammate = teammates[0];

        if (teammate && teammate.user) {
          nonCurrentUserId = teammate.user.id;
        }
      }
    }

    this.state = {
      show: false,
      currentUserId: hasSelfAssessmentQuestions ? userId : nonCurrentUserId,
      myselfUserId: userId,
      nonMyselfUserId: nonCurrentUserId,
      hasSelfAssessmentQuestions: hasSelfAssessmentQuestions,
      currentPage: 0,
      questionsOffset: 0,
      answers: {},
      errors: {},
      showFinalPage: false,
      feedback: null,
      finished_feedbacks: {},
      completed_feedbacks: [],
      readonly_mode: false
    };
  }

  async getFeedback(data) {
    const { readonly_mode } = this.state;
    let feedback = null;

    if (readonly_mode === false) {
      const { body } = await postRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/`
      ).send(data);
      feedback = body;
    } else {
      let query = "";
      Object.keys(data).forEach(q => {
        query = `${query}${query === "" ? "?" : "&"}${q}=${data[q]}`;
      });

      const { body } = await getRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/${query}`
      );

      if (body && body.results && body.results.length > 0) {
        feedback = body.results[0];
      }
    }

    return feedback;
  }

  async loadFeedback(set_completed = false) {
    const { survey } = this.props;
    const { currentUserId, myselfUserId } = this.state;
    const team = Teams.currentTeam();
    const sendData = {
      survey: survey.id,
      giver: myselfUserId,
      receiver: currentUserId,
      giver_team: team.id
    };

    const feedback = await this.getFeedback(sendData);

    const { body: answersData } = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/answers/`
    );

    const answers = {};
    if (answersData && answersData.length > 0 && feedback) {
      answersData
        .filter(answer => answer.feedback === feedback.id)
        .forEach(answer => {
          const question = survey.questions.find(
            q => q.id === answer.survey_question
          );
          answers[answer.survey_question] = {
            id: answer.id,
            answer_text:
              question.answer_type === "rating"
                ? parseInt(answer.text, 10)
                : answer.text
          };
        });
    }

    this.setState(
      {
        feedback,
        answers
      },
      () => {
        if (set_completed === true && feedback) {
          const { finished_feedbacks } = this.state;

          this.setState({
            finished_feedbacks: {
              ...finished_feedbacks,
              [feedback.id]: sendData
            }
          });
        }
      }
    );
  }

  sendCompletedAll() {
    const { finished_feedbacks } = this.state;

    Object.keys(finished_feedbacks).forEach(feedback_id => {
      this.sendCompleted(feedback_id, finished_feedbacks[feedback_id]);
    });
  }

  async sendCompleted(feedback_id, sendData) {
    const { readonly_mode } = this.state;

    if (readonly_mode === false) {
      await putRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/feedbacks/${feedback_id}/`
      ).send({
        ...sendData,
        completed: true
      });
    }

    const { completed_feedbacks } = this.state;
    this.setState(
      {
        completed_feedbacks: [...completed_feedbacks, feedback_id]
      },
      () => {
        if (
          this.state.completed_feedbacks.length ===
          Object.keys(this.state.finished_feedbacks).length
        ) {
          this.setState({
            completed_feedbacks: [],
            finished_feedbacks: {}
          });
        }
      }
    );
  }

  sendAnswers(newState, callback = null) {
    const { currentPage, feedback, readonly_mode } = this.state;

    if (
      this.questions[currentPage] &&
      this.questions[currentPage].length > 0 &&
      readonly_mode === false
    ) {
      this.questions[currentPage].forEach(async question => {
        const answer = this.getAnswer(question.id);

        if (answer.id === 0) {
          await postRequest(
            `${process.env.REACT_APP_API_URL}v2/forms/answers/`
          ).send({
            feedback: feedback.id,
            survey_question: question.id,
            text: answer.answer_text
          });
        } else {
          await putRequest(
            `${process.env.REACT_APP_API_URL}v2/forms/answers/${answer.id}/`
          ).send({
            feedback: feedback.id,
            survey_question: question.id,
            text: answer.answer_text
          });
        }
      });
    }

    this.setState(newState, () => {
      if (callback) {
        callback();
      }
    });
  }

  handleShowModal = () => {
    if (this.isLinkActive) {
      this.setState({ show: !this.state.show }, () => {
        if (this.state.show === true) {
          this.setState(
            {
              currentUserId: this.state.hasSelfAssessmentQuestions
                ? this.state.myselfUserId
                : this.state.nonMyselfUserId,
              currentPage: 0,
              questionsOffset: 0,
              errors: {},
              showFinalPage: false,
              feedback: null,
              completed_feedbacks: [],
              finished_feedbacks: {},
              readonly_mode: false
            },
            () => {
              this.loadFeedback();
            }
          );
        }
      });
    } else {
      this.setState({ show: !this.state.show }, () => {
        if (this.state.show === true) {
          this.setState(
            {
              currentUserId: this.state.hasSelfAssessmentQuestions
                ? this.state.myselfUserId
                : this.state.nonMyselfUserId,
              currentPage: 0,
              questionsOffset: 0,
              errors: {},
              showFinalPage: false,
              feedback: null,
              completed_feedbacks: [],
              finished_feedbacks: {},
              readonly_mode: true
            },
            () => {
              this.loadFeedback();
            }
          );
        }
      });
    }
  };

  get isLinkNotActive() {
    const { survey } = this.props;

    const startDate = moment(survey.start);
    const currentDate = moment.utc();

    return currentDate.isBefore(startDate);
  }

  get isLinkActive() {
    const { survey } = this.props;

    const startDate = moment(survey.start);
    const endDate = moment(survey.end);
    const currentDate = moment.utc();

    return (
      currentDate.isSameOrAfter(startDate) &&
      currentDate.isSameOrBefore(endDate)
    );
  }

  get questions() {
    const { currentUserId, myselfUserId } = this.state;
    const { survey } = this.props;
    const { questions } = survey;

    const group1 = _.groupBy(
      questions.map(question => {
        const category =
          question.category === "self_assessment"
            ? "self_assessment"
            : "non_self_assessment";

        return { ...question, category };
      }),
      "category"
    );

    const group2 =
      currentUserId === myselfUserId
        ? _.get(group1, "self_assessment", [])
        : _.get(group1, "non_self_assessment", []);

    const group3 = _.groupBy(_.sortBy(group2, "list_order"), "answer_type");

    const rating = _.chunk(_.get(group3, "rating", []), 4);
    const freeform = _.chunk(_.get(group3, "freeform", []), 2);

    return [...rating, ...freeform];
  }

  get title() {
    const { currentUserId, myselfUserId } = this.state;

    if (currentUserId === myselfUserId) {
      return "Self Assessment";
    }

    const userIndex = this.team.findIndex(i => i.user.id === currentUserId);

    return userIndex > -1 ? `Team Member: ${userIndex}` : null;
  }

  get subtitle() {
    const { currentUserId, myselfUserId } = this.state;

    if (currentUserId === myselfUserId) {
      return null;
    }

    const user = this.team.find(i => i.user.id === currentUserId);

    return user ? `${user.user.first_name} ${user.user.last_name}` : null;
  }

  get team() {
    return [this.myself, ...this.teammates];
  }

  get myself() {
    const { myselfUserId } = this.state;
    const team = Teams.currentTeam();
    const players = Teams.players();

    return players.find(player => {
      return player.team === team.id && player.user.id === myselfUserId;
    });
  }

  get teammates() {
    const { myselfUserId } = this.state;
    const team = Teams.currentTeam();
    const players = Teams.players();

    return players.filter(player => {
      return player.team === team.id && player.user.id !== myselfUserId;
    });
  }

  getCountOfWords = str => {
    str = str.replace(/(^\s*)|(\s*$)/gi, "");
    str = str.replace(/[ ]{2,}/gi, " ");
    str = str.replace(/\n /, "\n");

    return str.split(" ").filter(w => w !== "").length;
  };

  checkErrors = () => {
    const errors = {};
    const { currentPage } = this.state;

    if (this.questions[currentPage] && this.questions[currentPage].length > 0) {
      this.questions[currentPage].forEach(question => {
        const answer = this.getAnswer(question.id);
        if (question.answer_type === "rating") {
          let value = parseInt(answer.answer_text, 10);
          if (isNaN(value)) {
            value = 0;
          }

          if (value === 0) {
            errors[question.id] =
              "Please provide a rating for all questions before you can continue.";
          }
        } else if (question.answer_type === "freeform") {
          let value = answer.answer_text;
          if (!value) {
            value = "";
          }

          if (
            question.text ===
            "Besides yourself, who is the most valuable person on your team?" ||
            question.text ===
            "Besides yourself, who was the most valuable person on your team?"
          ) {
            const possible_answers = this.teammates
              .map(i => i.user)
              .map(i => i.username);
            if (value.length === 0 || !possible_answers.includes(value)) {
              errors[question.id] =
                "The most valuable person should be selected";
            }
          } else if (
            question.text === "Would you want to work with this teammate again?"
          ) {
            if (value.length === 0) {
              errors[question.id] = "Please answer on the question";
            }
          } else {
            if (this.getCountOfWords(value) < 10) {
              errors[question.id] =
                "Your feedback is too short. Please ensure that it is at least 60 words long.";
            } else if (this.getCountOfWords(value) > 200) {
              errors[question.id] =
                "Your feedback is too long. Please ensure that it is not more than 200 words long.";
            }
          }
        }
      });
    }

    this.setState({
      errors
    });

    return Object.keys(errors).length > 0 ? true : false;
  };

  get hasErrors() {
    return Object.keys(this.state.errors).length > 0 ? true : false;
  }

  get isFirstPage() {
    const {
      currentUserId,
      myselfUserId,
      currentPage,
      hasSelfAssessmentQuestions,
      nonMyselfUserId
    } = this.state;
    const initialUserId = hasSelfAssessmentQuestions
      ? myselfUserId
      : nonMyselfUserId;

    return currentUserId === initialUserId && currentPage === 0;
  }

  goBack = () => {
    const {
      currentPage,
      questionsOffset,
      currentUserId,
      showFinalPage
    } = this.state;
    const questions = this.questions;

    if (showFinalPage) {
      this.setState({
        showFinalPage: false
      });
    } else if (currentPage > 0) {
      this.setState({
        currentPage: currentPage - 1,
        questionsOffset: questionsOffset - questions[currentPage - 1].length,
        errors: {}
      });
    } else {
      const { hasSelfAssessmentQuestions } = this.state;
      const team = hasSelfAssessmentQuestions ? this.team : this.teammates;
      const teamIndex = team.findIndex(
        player => player.user.id === currentUserId
      );

      if (teamIndex > 0) {
        this.setState(
          {
            currentUserId: team[teamIndex - 1].user.id,
            errors: {}
          },
          () => {
            const new_questions = this.questions;
            const questions_count = Object.values(new_questions).map(
              el => el.length
            );
            questions_count.splice(-1, 1);

            this.setState(
              {
                currentPage: new_questions.length - 1,
                questionsOffset: _.sum(questions_count)
              },
              () => {
                this.loadFeedback();
              }
            );
          }
        );
      }
    }
  };

  onSubmit = () => {
    const {
      currentPage,
      questionsOffset,
      currentUserId,
      showFinalPage,
      readonly_mode
    } = this.state;

    if (showFinalPage) {
      this.setState(
        {
          show: false
        },
        () => {
          this.sendCompletedAll();
        }
      );
      return;
    }

    const questions = this.questions;
    const hasErrors = readonly_mode ? false : this.checkErrors();

    if (hasErrors === true) {
      return;
    }

    if (currentPage < questions.length - 1) {
      this.sendAnswers({
        currentPage: currentPage + 1,
        questionsOffset: questionsOffset + questions[currentPage].length,
        errors: {}
      });
    } else {
      const { hasSelfAssessmentQuestions } = this.state;
      const team = hasSelfAssessmentQuestions ? this.team : this.teammates;
      const teamIndex = team.findIndex(
        player => player.user.id === currentUserId
      );

      if (teamIndex < team.length - 1) {
        this.sendAnswers(
          {
            currentPage: 0,
            questionsOffset: 0,
            currentUserId: team[teamIndex + 1].user.id,
            errors: {}
          },
          () => {
            this.loadFeedback(true);
          }
        );
      } else {
        this.sendAnswers({
          showFinalPage: true
        });
      }
    }
  };

  onSaveDraft = () => {
    const hasErrors = this.checkErrors();
    if (hasErrors === true) {
      return;
    }

    this.sendAnswers({
      show: false,
      errors: {}
    });
  };

  setAnswer = (question_id, answer_text) => {
    const { answers } = this.state;
    const answer =
      question_id in answers
        ? { ...answers[question_id], answer_text }
        : {
          id: 0,
          answer_text
        };

    this.setState({
      answers: {
        ...answers,
        [question_id]: answer
      }
    });
  };

  getAnswer = question_id => {
    const { answers } = this.state;

    return question_id in answers
      ? answers[question_id]
      : { id: 0, answer_text: null };
  };

  getError = question_id => {
    const { errors } = this.state;

    return question_id in errors ? errors[question_id] : null;
  };

  render() {
    const {
      show,
      currentPage,
      questionsOffset,
      showFinalPage,
      readonly_mode
    } = this.state;

    const { survey, isStarted, isEnded } = this.props;

    return (
      <div className="survey-quiz">
        <PeerEvaluationCard
          survey={survey}
          onClick={this.handleShowModal}
          isActive={this.isLinkActive}
          isEnded={isEnded}
          isStarted={isStarted}
        />
        <PeerEvaluationModal
          show={show}
          onHide={this.handleShowModal}
        // title={this.title}
        // subtitle={this.subtitle}
        // feedbackType={`${surveyStage} Feedback`}
        // onSubmit={this.onSubmit}
        // onSaveDraft={this.onSaveDraft}
        // submitButtonText={showFinalPage ? "Close" : "Next"}
        // showFinalMessage={showFinalPage}
        // showBackButton={!this.isFirstPage}
        // goBack={this.goBack}
        // backdrop={readonly_mode === true ? true : "static"}
        // keyboard={false}
        // readonly_mode={readonly_mode}
        >
          {!showFinalPage && (
            <Feedback
              questions={this.questions[currentPage]}
              questionsOffset={questionsOffset}
              setAnswer={this.setAnswer}
              getAnswer={this.getAnswer}
              showErrors={this.hasErrors}
              getError={this.getError}
              teammates={this.teammates}
              readonly_mode={readonly_mode}
            />
          )}
          {showFinalPage && (
            <FinalMessage>
              Congratulations! You've completed your {survey.name}. You can
              revisit and modify this survey at any time before the deadline.
            </FinalMessage>
          )}
        </PeerEvaluationModal>
      </div>
    );
  }
}

export default withRouter(Quiz);



// WEBPACK FOOTER //
// ./src/components/quiz/index.js